import { useEffect, useRef } from "react";
import { DEFAULT_YAK_TRAILS_CONFIG, type GameSnapshot } from "@games-monorepo/yak-trails-core";

import { YAK_TRAILS_CLIENT_TUNING } from "../tuning";

const COLORS = ["#ffca3a", "#19d3c5", "#ff5d8f", "#7b61ff", "#4cc9f0", "#ff7b00", "#80ed99", "#e76f51"];

export function MiniMap({ snapshot, owners, playerId }: { snapshot: GameSnapshot; owners: Array<string | null>; playerId: string }) {
  const canvas = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const context = canvas.current?.getContext("2d");
    if (!context) return;
    const size = YAK_TRAILS_CLIENT_TUNING.minimap.pixels;
    const gridSize = DEFAULT_YAK_TRAILS_CONFIG.world.gridSize;
    const worldRadius = DEFAULT_YAK_TRAILS_CONFIG.world.radius;
    context.clearRect(0, 0, size, size);
    context.fillStyle = "rgba(232,255,248,.9)";
    context.beginPath();
    context.arc(size / 2, size / 2, size / 2 - 2, 0, Math.PI * 2);
    context.fill();
    const colorById = new Map(snapshot.players.map((player, index) => [player.id, player.color ?? COLORS[index % COLORS.length]! ]));
    const step = YAK_TRAILS_CLIENT_TUNING.minimap.ownershipSampleStep;
    for (let row = 0; row < gridSize; row += step) {
      for (let column = 0; column < gridSize; column += step) {
        const ownerId = owners[row * gridSize + column];
        if (!ownerId) continue;
        context.fillStyle = colorById.get(ownerId) ?? "#7dd3c7";
        context.fillRect(
          column / gridSize * size,
          row / gridSize * size,
          step / gridSize * size + 0.5,
          step / gridSize * size + 0.5,
        );
      }
    }
    for (const player of snapshot.players) {
      if (player.status !== "active") continue;
      context.fillStyle = player.id === playerId ? "#ffffff" : player.color;
      context.strokeStyle = "#17333a";
      context.lineWidth = player.id === playerId
        ? YAK_TRAILS_CLIENT_TUNING.minimap.selfLineWidth
        : YAK_TRAILS_CLIENT_TUNING.minimap.remoteLineWidth;
      context.beginPath();
      context.arc(
        (player.x + worldRadius) / (worldRadius * 2) * size,
        (player.y + worldRadius) / (worldRadius * 2) * size,
        player.id === playerId
          ? YAK_TRAILS_CLIENT_TUNING.minimap.selfRadius
          : YAK_TRAILS_CLIENT_TUNING.minimap.remoteRadius,
        0,
        Math.PI * 2,
      );
      context.fill();
      context.stroke();
    }
  }, [owners, playerId, snapshot]);
  return (
    <canvas
      ref={canvas}
      className="yak-trails__minimap"
      width={YAK_TRAILS_CLIENT_TUNING.minimap.pixels}
      height={YAK_TRAILS_CLIENT_TUNING.minimap.pixels}
      aria-label="Arena minimap"
    />
  );
}
